module.exports = __webpack_public_path__ + "img/fb_logo.3c0fe5cb.svg";